import React, { useEffect, useState } from "react";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import {
  Box,
  Card,
  CircularProgress,
  // Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  // TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { EmptyContainer } from "../../../utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import { getCreditDebitNote } from "../redux/userOrdersSlice";
import moment from "moment";
const UserCreditDebitNoteTableContent = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const { creditDebitNote, creditDebitNote_loading } = useSelector(
    (state) => state.userOrders
  );
  const columns = [
    { label: "PO Number", key: "order_number" },
    { label: "Note Number", key: "note_number" },
    { label: "Note Type", key: "note_type" },
    { label: "Amount", key: "amount" },
    { label: "Quantity", key: "quantity" },
    { label: "Date of Issue", key: "note_date" },
    { label: "Reason for Adjustment", key: "remark" },
  ];

  const getCreditDebitNoteDetails = () => {
    dispatch(
      getCreditDebitNote({
        page: page,
        per_page: perPage,
      })
    );
  };

  useEffect(() => {
    getCreditDebitNoteDetails();
    // eslint-disable-next-line
  }, [page, perPage]);
  return creditDebitNote_loading ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <CustomTableContainer component={Card}>
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell key={index}>
                <TableHeaderFont>{column.label}</TableHeaderFont>
              </TableCell>
            ))}
          </TableRow>
        </CustomTableHead>
        <TableBody>
          {creditDebitNote?.data && creditDebitNote?.data?.length > 0 ? (
            creditDebitNote?.data?.map((item, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {columns.map((column, index) => (
                  <TableCell key={index}>
                    {column.key === "order_number" ? (
                      item?.Order?.[column.key]
                    ) : column?.key === "note_date" ? (
                      moment(item?.[column.key]).format("DD MMM YYYY")
                    ) : column.key === "remark" &&
                      item?.[column.key]?.length > 20 ? (
                      <Tooltip title={item?.[column.key]} placement="top">
                        <span>{item?.[column.key].substring(0, 20)}...</span>{" "}
                      </Tooltip>
                    ) : (
                      item?.[column.key] || "-"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length}>
                <CustomTableContainer>
                  <EmptyContainer text="There are no credit/debit note to display" />
                </CustomTableContainer>
              </TableCell>
            </TableRow>
          )}
        </TableBody>

        <TableFooter style={{ borderTop: "1px solid lightgray" }}>
          <TableRow>
            <TableCell colSpan={columns.length}>
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="flex items-center gap-2 "
                  style={{
                    fontSize: "14px",
                  }}
                >
                  <span>Rows per page: </span>
                  <select
                    value={perPage}
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                      setPage(1);
                    }}
                    className="border border-gray-300  px-2 py-1 focus:outline-none focus:border-blue-500"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
                <Pagination
                  color="primary"
                  variant="text"
                  onChange={(_, newValue) => setPage(newValue)}
                  count={creditDebitNote?.pagination?.total_page}
                  page={page}
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </CustomTableContainer>
  );
};

export default UserCreditDebitNoteTableContent;
